<section class="workflow-step-container" [ngClass]="{'active':activeIndex>=currentIndex}">
  <div class="top-bar">
    <span class="border" [ngClass]="{'hidden-border':stepItem.pos=='first' || stepItem.singleStep,'not-active':activeIndex<currentIndex}"></span>
    <div class="point-z-index">
      <span class="point" [ngClass]="{'not-active':activeIndex<currentIndex,'disable-label':stepItem.isSkipped}"></span>
    </div>
    <span class="border"
          [ngClass]="{'hidden-border':stepItem.pos=='last' || stepItem.singleStep,'not-active':activeIndex<=currentIndex}"></span>
  </div>
  <span class="step-label" [ngClass]="{'not-active':activeIndex<currentIndex,'disable-label':stepItem.isSkipped}" genTooltip [tooltipPosition]="'BOTTOM'" [tooltipHtml]="tooltipContent | translate"
        [tooltipShow]="stepItem.tooltip&&stepItem.tooltip.length>0" [innerHTML]="getHtml(stepItem.name) | translate"></span>
  <span class="sub-status-label" *ngIf="stepTaglineField && stepTaglineField.display && stepItem.isActive">{{stepTaglineField.display | translate}}</span>
  <span [class.has-elapsed]="hasElapsed" class="step-timestamp" *ngIf="stepItem.showLastStateChange && !alertRequired &&!showLastUpdatedDate">
    {{revision?.meta?.lastUpdated | date: 'd-MMM-yyyy'}}
  </span>
  <span [class.has-elapsed]="hasElapsed" class="step-timestamp" *ngIf="stepItem.showLastStateChange && alertRequired && showLastUpdatedDate">
    <span class="icon__ExclamationCircle__warning icon__ExclamationCircle" *ngIf="pastDueDate">
    </span>{{revision?.meta?.lastUpdated | date: 'd-MMM-yyyy'}}
  </span>
  <span [class.has-elapsed]="hasElapsed" class="step-timestamp" *ngIf="stepItem.showLastStateChange && alertRequired && !showLastUpdatedDate">
    <span class="icon__ExclamationCircle__warning icon__ExclamationCircle" *ngIf="pastDueDate">
    </span>{{revision?.dueDate | date: 'd-MMM-yyyy'}}
  </span>
</section>
<section class="template__html__tooltip">
  <span #parser></span>
</section>
